import { render, staticRenderFns } from "./RealizedGainLossLayout.vue?vue&type=template&id=705e6278&scoped=true"
import script from "./RealizedGainLossLayout.vue?vue&type=script&lang=js"
export * from "./RealizedGainLossLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705e6278",
  null
  
)

export default component.exports